const REPORT_TYPES = {
  INFRACTION: 'infraction',
  MODERATOR: 'moderator',
  ANALYTIC: 'activity',
};

export default REPORT_TYPES;
